import { Checkboxes } from 'components/Checkboxes/Checkboxes';
import { Field } from 'components/Form/Field/Field';

type Props = {
  'data-qa-id'?: string;
  id?: string;
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  onChange: (newValue: string[]) => void;
  type: 'OPTION_MANY';
  options: { value: string }[];
};

const getNewValue = ({
  value,
  option,
}: {
  value: string[];
  option: string;
}) => {
  return value.includes(option)
    ? value.filter((o) => o !== option)
    : [...value, option];
};

export function RequestedMultipleOptionField({
  id,
  name,
  label,
  description,
  disabled,
  'data-qa-id': qaId,
  type,
  options,
  onChange,
}: Props) {
  if (type !== 'OPTION_MANY') return null;
  const subName = `${name}.${type.toLowerCase()}`;

  return (
    <Field
      name={name}
      label={label}
      description={description}
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <Checkboxes
          data-qa-id={qaId ?? autoQaId}
          id={id}
          disabled={disabled}
          getValue={(name) => value?.options.includes(name)}
          options={options.map((o) => ({ label: o.value, name: o.value }))}
          onChange={(name) => {
            const newValue = getNewValue({
              value: value?.options ?? [],
              option: name,
            });

            onChange(newValue);

            updateValue({
              type: 'OPTION_MANY',
              options: newValue,
            });
          }}
        />
      )}
    />
  );
}
